document.addEventListener("DOMContentLoaded", function () {

  const organicEl = document.querySelector(".organic_swiper_wrap");
  if (!organicEl) return;

  const slides = organicEl.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)");
  const slideCount = slides.length;
  const enableSwiper = slideCount > 1;

  let organicSwiper = new Swiper(".organic_swiper_wrap", {
    loop: enableSwiper,
    allowTouchMove: enableSwiper,
    slidesPerView: enableSwiper ? 1.5 : 1,
    spaceBetween: 20,
    autoplay: enableSwiper ? { delay: 3000, disableOnInteraction: true } : false,
    pagination: enableSwiper ? {
      el: ".organic_pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="organic-bullet ' + className + '"></span>';
      },
    } : false,
    breakpoints: {
      400: { slidesPerView: 2, spaceBetween: 60 },
      1024: { slidesPerView: 3 },
    },
  });

  if (!enableSwiper) {
    const paginationEl = organicEl.querySelector(".organic_pagination");
    if (paginationEl) paginationEl.style.display = "none";
  }

  window.organicSwiper = organicSwiper;

  function setEqualSlideHeights() {
    const items = document.querySelectorAll('.organic_swiper .item');
    let maxHeight = 0;

    items.forEach(item => {
      item.style.height = 'auto';
    });

    items.forEach(item => {
      const h = item.offsetHeight;
      if (h > maxHeight) maxHeight = h;
    });

    items.forEach(item => {
      item.style.height = maxHeight + 'px';
    });
  }

  setEqualSlideHeights();
  window.addEventListener('resize', setEqualSlideHeights);

  /* ===============================
     ICON IMAGE LAZY LOAD (data-src)
  =============================== */

  function loadOrganicIcons() {
    organicEl.querySelectorAll('img.organic-lazy-img[data-src]').forEach(img => {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadOrganicIcons();
          obs.disconnect();
        }
      });
    }, {
      rootMargin: '200px',
      threshold: 0.1
    });

    observer.observe(organicEl);
  } else {
    loadOrganicIcons();
  }

});

